import p from "./ghl-ui.es1589.js";
import f from "./ghl-ui.es1590.js";
import s from "./ghl-ui.es1586.js";
import c from "./ghl-ui.es1587.js";
import l from "./ghl-ui.es1588.js";
import o from "./ghl-ui.es1591.js";
import { Parser as h } from "./ghl-ui.es1670.js";
import { numericPatterns as y } from "./ghl-ui.es1672.js";
import { parseNDigits as v, parseNumericPattern as D, isLeapYearIndex as Y } from "./ghl-ui.es1671.js";
var L = /* @__PURE__ */ function(u) {
  c(i, u);
  var n = l(i);
  function i() {
    var a;
    p(this, i);
    for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
      e[t] = arguments[t];
    return a = n.call.apply(n, [this].concat(e)), o(s(a), "priority", 90), o(s(a), "subpriority", 1), o(s(a), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), a;
  }
  return f(i, [{
    key: "parse",
    value: function(r, e, t) {
      switch (e) {
        case "D":
        case "DD":
          return D(y.dayOfYear, r);
        case "Do":
          return t.ordinalNumber(r, {
            unit: "date"
          });
        default:
          return v(e.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, e) {
      var t = r.getUTCFullYear(), m = Y(t);
      return m ? e >= 1 && e <= 366 : e >= 1 && e <= 365;
    }
  }, {
    key: "set",
    value: function(r, e, t) {
      return r.setUTCMonth(0, t), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), i;
}(h);
export {
  L as DayOfYearParser
};
